import 'assets/css/saveBtn.css';
import ReactiveButton from 'reactive-button';
import styles from 'assets/css/saveBtn.module.css';
import { Button } from '@mui/material';

const SaveButton = ({ saveBtn, disabled }) => {
  const isDisable = saveBtn?.wait || saveBtn?.loading || disabled;
  const disableTextStyle = { color: disabled && '#BBBBBB', opacity: '1' };

  const btnStyle = {
    width: '125.5px ',
    backgroundColor: '#F4F4F4 ',
    border: '1px solid #FFFFFF ',
    boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 15px rgba(0, 0, 0, 0.08) ',
    borderRadius: '16px ',
    color: '#707070 !important',
    outline: 'none',
    height: '30px',
    padding: '0 ',
    '&:active': {
      boxShadow:
        'inset -6px 6px 15px rgba(255, 255, 255, 0.78), inset 6px 6px 14px rgba(131, 131, 131, 0.4) ',
    },
    '&:hover': {
      bgcolor: '#F4F4F4 !important',
    },
  };
  return (
    <div dir="rtl">
      <Button disableFocusRipple sx={btnStyle} disabled={isDisable}>
        <ReactiveButton
            type='submit'
          buttonState={saveBtn?.loading ? 'loading' : 'idle'}
          idleText={
            <span className={saveBtn?.wait ? styles.doneText : styles.saveText}>
              {saveBtn?.wait ? (
                'انجام شد'
              ) : (
                <span style={disableTextStyle}>ذخیره</span>
              )}
            </span>
          }
          loadingText={<span className={styles.waitStyle}>صبر کنید...</span>}
          disabled={isDisable}
          animation={false}
        />
      </Button>
    </div>
  );
};

export default SaveButton;
